import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import LayoutLegacy
  from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/Sections/Income/LayoutLegacy';
import {
  LayoutActivePassiveIncomes,
} from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/Sections/Income/LayoutActivePassiveIncomes';

const LAYOUT_MAP = {
  OnboardingIncomeInformation: LayoutActivePassiveIncomes,
  DetailList: LayoutLegacy,
};

export function useOnboardingSectionViewIncomeLayout() {
  const {
    resource,
  } = useMetaLayoutContext();
  const [sectionDataResource] = resource.attr('sectionData');

  return LAYOUT_MAP[sectionDataResource.type()];
}
